// extracted by mini-css-extract-plugin
module.exports = {"archidektOrange":"var(--archidekt-orange)","quantityBlue":"#698bc7","quantityGreen":"#1ebb6c","flex":"variables_flex__8QMYu","pulse":"variables_pulse__ec2yK"};